import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const RoleRoute = ({ allowedRoles }) => {
    const { hasRole, isAuthenticated, loading } = useAuth();

    // Check if user is authenticated and has any of the allowed roles
    const hasAccess = () => {
        if (!isAuthenticated()) return false;

        // If allowedRoles is an array, check if user has any of the roles
        if (Array.isArray(allowedRoles)) {
            return allowedRoles.some(role => hasRole(role));
        }

        // If allowedRoles is a string, check if user has that role
        return hasRole(allowedRoles);
    };

    // Show loading indicator while checking authentication
    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-600"></div>
            </div>
        );
    }

    // Redirect to dashboard if authenticated but not authorized
    if (isAuthenticated() && !hasAccess()) {
        return <Navigate to="/admin/dashboard" replace />;
    }

    // Redirect to login if not authenticated
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }

    // Render children routes if authenticated and authorized
    return <Outlet />;
};

export default RoleRoute;